/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Addr_Sugg_CountInputs */

const cs_addr_sugg_count = /** @type {(inputs: Addr_Sugg_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} návrhů`)
};

const en_addr_sugg_count = /** @type {(inputs: Addr_Sugg_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} suggestions`)
};

/**
* | output |
* | --- |
* | "{count} suggestions" |
*
* @param {Addr_Sugg_CountInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_sugg_count = /** @type {((inputs: Addr_Sugg_CountInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Sugg_CountInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_sugg_count(inputs)
	return cs_addr_sugg_count(inputs)
});